// extracted by mini-css-extract-plugin
module.exports = {"blocked":"src-components-NewClientsSection-NewUserModal-NewUsersModal-module__blocked--5x0_5"};